import { render, staticRenderFns } from "./BookingExtras.vue?vue&type=template&id=c5e67e04&"
import script from "./BookingExtras.vue?vue&type=script&lang=js&"
export * from "./BookingExtras.vue?vue&type=script&lang=js&"
import style0 from "./BookingExtras.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports